import styles from "./GamePage.module.css";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import AnimatedGamePage from "../AnimatedPage/AnimatedGamePage";
import NavBar from "../../Components/NavBar/NavBar";
import { ReactComponent as Arrow } from "../../Resources/image/arrow.svg";
import { ReactComponent as Up } from "../../Resources/image/up.svg";
import { ReactComponent as Down } from "../../Resources/image/down.svg";
import { ReactComponent as Like } from "../../Resources/image/like.svg";
import Slider from "../../Components/Slider/Slider";
import games from "../../utils/games";
import AnimatedText from "../AnimatedPage/AnimatedText";
import { ReactComponent as Add } from "../../Resources/image/add.svg";
import AddedToCartBig from "../../Components/AddedToCart/AddedToCartBig";
import Login from "../../Components/Login/Login";
import templateGame from "../../utils/templateGame";
import Sidebar from "../../Components/Sidebar/Sidebar";
import { t } from "../../utils/i18n";

const GamePage = props => {
  const {
    handleHover,
    hoverState,
    handleHome,
    landingPage,
    cartAmount,
    cart,
    search,
    searching,
    handleSearch,
    handleSearchSubmit,
    browsing,
    handleBrowse,
    selectedGame,
    setSelectedGame,
    allGames,
    extended,
    setExtended,
    handleAddToCart,
    handleLike,
    textExtended,
    setTextExtended,
    handleOpenLogin,
    handleCloseCart,
    handleLoginSuccess,
    handleLogout,
    isLoggedIn,
    cartDisplayed,
    clearCart,
    handleRemoveFromCart,
    openGamePage,
    theme,
    setTheme,
  } = props;

  let { gameId } = useParams();
  const location = useLocation();
  const [carouselState, setCarouselState] = useState(0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const incrementCarousel = e => {
    if (carouselState === 3) {
      setCarouselState(0);
    } else {
      setCarouselState(carouselState + 1);
    }
  };

  const decrementCarousel = e => {
    if (carouselState === 0) {
      setCarouselState(3);
    } else {
      setCarouselState(carouselState - 1);
    }
  };

  const extendText = () => {
    setTextExtended(!textExtended);
  };

  const handleExtend = e => {
    if (document.getElementById("20").innerHTML === "More") {
      document.getElementById("20").className = "aboutBottom";
    } else if (document.getElementById("20").innerHTML === "Hide") {
      document.getElementById("20").className = "aboutBottomClosed";
    }
    setExtended(!extended);
    if (textExtended === false) {
      setTimeout(extendText, 500);
    } else {
      setTextExtended(!textExtended);
    }
  };

  return (
    <div className={styles.page}>
      {cartDisplayed ? (
        <Login
          cartDisplayed={cartDisplayed}
          handleCloseCart={handleCloseCart}
          onLoginSuccess={handleLoginSuccess}
          handleHover={handleHover}
          hoverState={hoverState}
        />
      ) : null}

      <div className={styles.container}>
        {/* Sidebar 组件 */}
        <Sidebar
          isOpen={isMobileMenuOpen}
          onClose={() => setIsMobileMenuOpen(false)}
          theme={theme}
          setTheme={setTheme}
          isLoggedIn={isLoggedIn}
          handleOpenLogin={handleOpenLogin}
        />

        {/* Content Column: Header + Main */}
        <div className={styles.contentColumn}>
          {/* Header */}
          <header className={styles.header}>
            {/* 移动端 Header 元素 */}
            <div className={styles.mobileHeaderLeft}>
              <button
                className={styles.hamburgerBtn}
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                aria-label={t("aria.menu", "Menu")}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </button>
            </div>

            {/* 桌面端操作区 */}
            <div className={styles.headerActions}>
              {isLoggedIn ? (
                <div className={styles.avatarPlaceholder}>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                </div>
              ) : (
                <div
                  className={styles.avatarPlaceholder}
                  onClick={handleOpenLogin}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                </div>
              )}
            </div>
          </header>

          {/* Main Content */}
          <main className={styles.main}>
            <AnimatedGamePage>
              <div className={styles.gamepageContent}>
                <header>
                  <button
                    style={{
                      color: hoverState[19].hovered ? "#92f" : "#cccccc",
                    }}
                    className={styles.goBack}
                    onMouseEnter={handleHover}
                    onMouseLeave={handleHover}
                    onClick={handleBrowse}
                    id="19"
                    aria-label={t("aria.back", "Back")}
                  >
                    <Arrow
                      style={{
                        fill: hoverState[19].hovered ? "#92f" : "#cccccc",
                      }}
                      className={styles.arrow}
                    />
                    Store
                  </button>

                  <h1>
                    {selectedGame ? selectedGame.name : templateGame.name}
                  </h1>
                </header>

                <section className={styles.game}>
                  {
                    <Slider
                      selectedGame={selectedGame}
                      setSelectedGame={setSelectedGame}
                      allGames={allGames}
                      incrementCarousel={incrementCarousel}
                      decrementCarousel={decrementCarousel}
                      carouselState={carouselState}
                      setCarouselState={setCarouselState}
                      hoverState={hoverState}
                      handleHover={handleHover}
                    />
                  }
                  <div className={styles.gameInfo}>
                    <div className={styles.about}>
                      <div className={styles.aboutTop}>
                        <h2>{t("legacyGamePage.about", "About")}</h2>
                        <div
                          className={styles.aboutTopDesc}
                          dangerouslySetInnerHTML={{
                            __html:
                              (selectedGame
                                ? selectedGame.desc
                                : templateGame.desc) || "",
                          }}
                        />
                      </div>
                      <div
                        className={
                          extended
                            ? `${styles.conditionalOpen} ${styles.aboutBottom}`
                            : `${styles.conditionalClose} ${styles.aboutBottomClosed}`
                        }
                        id="about"
                      >
                        <AnimatedText>
                          <div
                            className={
                              textExtended ? styles.open : styles.closed
                            }
                          >
                            <a
                              href={
                                selectedGame
                                  ? selectedGame.link
                                  : templateGame.link
                              }
                              target="_blank"
                            >
                              {selectedGame ? selectedGame.name : t("legacyGamePage.none", "No")}{" "}
                              {t("legacyGamePage.website", "Website")}
                            </a>
                            <h4>
                              {t("legacyGamePage.released", "Released")}:{" "}
                              {selectedGame
                                ? selectedGame.release
                                : templateGame.release}
                            </h4>
                            <h4>
                              {t("legacyGamePage.platforms", "Platforms")}:{" "}
                              {selectedGame
                                ? selectedGame.platforms
                                : templateGame.platforms}
                            </h4>
                            <h4>
                              {t("legacyGamePage.mainGenre", "Main Genre")}:{" "}
                              {selectedGame
                                ? selectedGame.genre
                                : templateGame.genre}
                            </h4>
                            <h4>
                              {t("legacyGamePage.developers", "Developers")}:{" "}
                              {selectedGame
                                ? selectedGame.developers
                                : templateGame.developers}
                            </h4>
                            <h4 className={styles.lastChild}>
                              {t("legacyGamePage.publishers", "Publishers")}:{" "}
                              {selectedGame
                                ? selectedGame.publishers
                                : templateGame.publishers}
                            </h4>
                          </div>
                        </AnimatedText>

                        <button
                          id="20"
                          onClick={handleExtend}
                          onMouseEnter={handleHover}
                          onMouseLeave={handleHover}
                          className={
                            hoverState[20].hovered
                              ? styles.buttonHovered
                              : styles.buttonNotHovered
                          }
                          aria-label={t("aria.extend", "Extend")}
                        >
                          {extended
                            ? t("legacyGamePage.hide", "Hide")
                            : t("legacyGamePage.more", "More")}
                          {extended ? (
                            <Up
                              className={styles.up}
                              style={{
                                fill: hoverState[20].hovered
                                  ? "#fff"
                                  : "#cccccc",
                              }}
                            />
                          ) : (
                            <Up
                              className={styles.down}
                              style={{
                                fill: hoverState[20].hovered
                                  ? "#fff"
                                  : "#cccccc",
                              }}
                            />
                          )}
                        </button>
                      </div>
                    </div>

                    <div className={styles.addToCart}>
                      <div className={styles.infos}>
                        <h3>
                          $
                          {selectedGame
                            ? selectedGame.price
                            : templateGame.price}
                        </h3>
                        <button
                          id={selectedGame ? selectedGame.id : templateGame.id}
                          onClick={handleLike}
                          aria-label={t("aria.like", "Like")}
                        >
                          <Like
                            className={
                              selectedGame
                                ? selectedGame.isLiked
                                  ? styles.liked
                                  : styles.like
                                : styles.like
                            }
                          />
                        </button>
                      </div>
                      {selectedGame ? (
                        selectedGame.inCart ? (
                          <AddedToCartBig />
                        ) : (
                          <button
                            id="21"
                            onMouseEnter={handleHover}
                            onMouseLeave={handleHover}
                            className={styles.addToCartButton}
                            style={{
                              color: hoverState[21].hovered
                                ? "#92f"
                                : "#999999",
                            }}
                            onClick={handleAddToCart}
                            aria-label={t("aria.add", "Add")}
                          >
                            Add to cart
                            <Add
                              className={styles.add}
                              style={{
                                fill: hoverState[21].hovered
                                  ? "#92f"
                                  : "#999999",
                              }}
                            />
                          </button>
                        )
                      ) : (
                        <button
                          id="21"
                          onMouseEnter={handleHover}
                          onMouseLeave={handleHover}
                          style={{
                            color: hoverState[21].hovered
                              ? "#D2042D"
                              : "#999999",
                          }}
                          onClick={handleAddToCart}
                          aria-label={t("aria.add", "Add")}
                        >
                          {t("legacyGamePage.notAvailable", "Not available")}
                          <Add
                            className={styles.add}
                            style={{
                              fill: hoverState[21].hovered
                                ? "#D2042D"
                                : "#999999",
                            }}
                          />
                        </button>
                      )}
                    </div>
                  </div>
                </section>
              </div>
            </AnimatedGamePage>
          </main>
        </div>
      </div>
    </div>
  );
};

export default GamePage;
